import React from "react";
import PropTypes from "prop-types";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useTranslation } from "react-i18next";
import { blendColors } from "assets/jss/material-dashboard-pro-react";

/**
 * Chip do filtro de período na barra de filtros.
 * Quando ativo, usa o mesmo blend "gray" do FilterTag legado:
 *   blendColors("#555555", clientColor, 0.5)
 */
export default function PeriodFilterButton({
  summary,
  onClick,
  active,
  clientColor,
}) {
  const { t } = useTranslation();
  const bg = active
    ? blendColors("#555555", clientColor || "#999", 0.5)
    : "#f0f0f0";
  const fg = active ? "#fff" : "#888";
  return (
    <div
      onClick={onClick}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        padding: "0 4px 0 8px",
        borderRadius: 20,
        backgroundColor: bg,
        cursor: "pointer",
        userSelect: "none",
        height: 20,
        whiteSpace: "nowrap",
        transition: "background 0.12s",
      }}
      title={t("results.filter_bar.period.button_title")}
    >
      <CalendarTodayIcon style={{ fontSize: 10, color: fg, flexShrink: 0 }} />
      <span
        style={{
          fontSize: 11,
          color: fg,
          letterSpacing: 0,
          textTransform: "lowercase",
        }}
      >
        {summary || t("results.filter_bar.period.title")}
      </span>
      <ExpandMoreIcon
        style={{
          fontSize: 13,
          color: active ? "rgba(255,255,255,0.65)" : "#fff",
          flexShrink: 0,
          marginLeft: -1,
        }}
      />
    </div>
  );
}

PeriodFilterButton.defaultProps = {
  active: true,
  summary: null,
  clientColor: null,
};

PeriodFilterButton.propTypes = {
  summary: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  active: PropTypes.bool,
  clientColor: PropTypes.string,
};
